module.exports = __webpack_public_path__ + "img/illustrator-drawing-dark.098962f9.svg";